const indexItems = [
  { title: '悬疑犯罪', desc: '高智商烧脑神作合集', count: '326部', icon: 'ri-search-eye-line' },
  { title: '古装奇幻', desc: '仙侠世界视觉盛宴', count: '218部', icon: 'ri-magic-line' },
  { title: '都市情感', desc: '温暖人心的生活故事', count: '452部', icon: 'ri-heart-pulse-line' },
  { title: '科幻未来', desc: '探索未知的想象力', count: '187部', icon: 'ri-rocket-2-line' },
  { title: '动作冒险', desc: '肾上腺素飙升体验', count: '394部', icon: 'ri-flashlight-line' },
  { title: '喜剧搞笑', desc: '轻松一刻快乐源泉', count: '281部', icon: 'ri-emotion-laugh-line' },
  { title: '恐怖惊悚', desc: '胆量挑战极限体验', count: '143部', icon: 'ri-ghost-smile-line' },
  { title: '战争历史', desc: '波澜壮阔史诗画卷', count: '109部', icon: 'ri-sword-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-400 bg-accent-500/10 rounded-full border border-accent-500/20 mb-3">
            专题索引
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 tracking-wide">
            主题分类 · 精准找片
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2 max-w-xl mx-auto">
            八大主题索引，助您快速定位心仪的影视内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="bg-background-100 rounded-lg border border-background-200/60 p-4 md:p-5 hover:border-primary-500/20 transition-all duration-300 cursor-pointer no-underline group"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-accent-500/10 mb-3 group-hover:bg-accent-500/20 transition-colors duration-300">
                <i className={`${item.icon} text-lg md:text-xl text-accent-400`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">{item.title}</h3>
              <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
              <span className="text-xs font-medium text-primary-400">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}